module.exports = __webpack_public_path__ + "img/dk.95d7653a.svg";